import { render, staticRenderFns } from "./BoardOverlay.vue?vue&type=template&id=72682cac&scoped=true&"
import script from "./BoardOverlay.vue?vue&type=script&lang=js&"
export * from "./BoardOverlay.vue?vue&type=script&lang=js&"
import style0 from "./BoardOverlay.vue?vue&type=style&index=0&id=72682cac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72682cac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer,VOverlay,VProgressCircular,VRow})
